import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { useState } from 'react';
import { useRsrc } from '../rsrc/RsrcContext';
import { StringUtils } from '../utils/StringUtils';

export const BookmarkDialog = ({ data, closeDialog }) => {
  const rsrc = useRsrc();
  const { bookmark, username, navState } = data;

  const isEdit = Boolean(bookmark);
  const [name, setName] = useState(bookmark?.name ?? '');

  const save = () => {
    const code = StringUtils.toCodeConvention(name);
    const entity =
      isEdit ?
        { ...bookmark, name, url: navState.url, navState: JSON.stringify(navState) }
      : { username, name, code, url: navState.url, navState: JSON.stringify(navState) };

    rsrc.save('admin', 'BOOKMARK', entity).then(() => closeDialog(true));
  };

  return (
    <Dialog onClose={() => closeDialog()} open fullWidth maxWidth="xs">
      <DialogTitle>{isEdit ? 'Edit Bookmark' : 'Add Bookmark'}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          label="Bookmark name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          sx={{ mt: 1 }}
          data-test-id="bookmark-name-input"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => closeDialog()} color="secondary" variant="outlined">
          Cancel
        </Button>
        <Button
          onClick={save}
          color="primary"
          variant="contained"
          disabled={!name.trim()}
          data-test-id="bookmark-save-button"
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};
